


















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { GetReactionIcon } from '@/core/reactions/Reactions';
import { NotificationViewObject, NotificationType } from '@/types/apiServerContract';
import { Emoji } from '@/core/constants';

import NotificationTypeNewsCreated from './types/NotificationTypeNewsCreated.vue';
import NotificationTypeNewsComment from './types/NotificationTypeNewsComment.vue';
import NotificationTypeNewsCommentReaction from './types/NotificationTypeNewsCommentReaction.vue';
import NotificationTypeNewsReaction from './types/NotificationTypeNewsReaction.vue';
import NotificationTypePrivateMessage from './types/NotificationTypePrivateMessage.vue';
import NotificationTypePrivateMessageReaction from './types/NotificationTypePrivateMessageReaction.vue';
import NotificationTypeIssueComment from './types/NotificationTypeIssueComment.vue';
import NotificationTypeIssueCreated from './types/NotificationTypeIssueCreated.vue';
import NotificationTypeIssueFixed from './types/NotificationTypeIssueFixed.vue';
import NotificationTypeIssueUpdated from './types/NotificationTypeIssueUpdated.vue';
import NotificationTypeIssueAssigned from './types/NotificationTypeIssueAssigned.vue';
import NotificationTypeIssueClosed from './types/NotificationTypeIssueClosed.vue';
import NotificationTypeIssueConfirmed from './types/NotificationTypeIssueConfirmed.vue';

import { NotificationApi } from '@/services/api/api.notifications';
import { UserModule } from '@/store/modules/user/user.store';

@Component({
    components: {
        NotificationTypeNewsCreated,
        NotificationTypeNewsComment,
        NotificationTypeNewsCommentReaction,
        NotificationTypeNewsReaction,
        NotificationTypePrivateMessage,
        NotificationTypePrivateMessageReaction,
        NotificationTypeIssueFixed,
        NotificationTypeIssueComment,
        NotificationTypeIssueCreated,
        NotificationTypeIssueUpdated,
        NotificationTypeIssueAssigned,
        NotificationTypeIssueClosed,
        NotificationTypeIssueConfirmed
    }
})
export default class Notification extends Vue {
	@Prop({ required: true, type: Object }) notification!: NotificationViewObject;

	loading = false;
	eyeIconHovering = false;

	get getReactionIcon(): Emoji {
	    return GetReactionIcon((this.notification as any).reactionType);
	}

	get notificationTypeName() {
	    switch (this.notification.type) {
	    case NotificationType.NewsReaction:
	        return 'News Reaction';
	    case NotificationType.NewsCommentReaction:
	        return 'News Comment Reaction';
	    case NotificationType.NewsComment:
	        return 'News Comment';
	    case NotificationType.NewsCreated:
	        return 'News Article Created';
	    case NotificationType.PrivateMessage:
	        return 'Message';
	    case NotificationType.PrivateMessageReaction:
	        return 'Message Reaction';
	    case NotificationType.IssueCreated:
	        return 'New Issue';
	    case NotificationType.IssueUpdated:
	        return 'Issue Updated';
	    case NotificationType.IssueFixed:
	        return 'Issue Fixed';
	    case NotificationType.IssueCommented:
	        return 'Issue Commented';
	    case NotificationType.IssueAssigned:
	        return 'Issue Assigned';
	    case NotificationType.IssueClosed:
	        return 'Issue Closed';
	    case NotificationType.IssueConfirmed:
	        return 'Issue Confirmed';
	    }

	    throw new Error('Unknown notification type: ' + this.notification.type);
	}

	get notificationIcon() {
	    switch (this.notification.type) {
	    case NotificationType.NewsReaction:
	        return 'thumb-up-outline';
	    case NotificationType.NewsCommentReaction:
	        return 'thumb-up-outline';
	    case NotificationType.NewsComment:
	        return 'comment';
	    case NotificationType.NewsCreated:
	        return 'newspaper-variant-multiple';
	    case NotificationType.PrivateMessage:
	        return 'comment-account';
	    case NotificationType.PrivateMessageReaction:
	        return 'thumb-up-outline';
	    case NotificationType.IssueCreated:
	        return 'ladybug';
	    case NotificationType.IssueUpdated:
	        return 'bug';
	    case NotificationType.IssueFixed:
	        return 'bug-check';
	    case NotificationType.IssueCommented:
	        return 'comment';
	    case NotificationType.IssueAssigned:
	        return 'bug';
	    case NotificationType.IssueClosed:
	        return 'bug';
	    case NotificationType.IssueConfirmed:
	        return 'bug-check';
	    }

	    throw new Error('Unknown notification type: ' + this.notification.type);
	}

	async markNotificationAsRead() {
	    this.loading = true;

	    try {
	        const result = await NotificationApi.MarkNotificationAsRead(this.notification.id);
	        if (result && result.data) {
	            this.$bvToast.toast(`Notification read successfully.\n\n${result.message}`, {
	                variant: 'success',
	                title: 'Success'
	            });
	            UserModule.NotificationSeen(this.notification);
	        }
	    } finally {
	        this.loading = false;
	    }
	}
}
